import CustomersUI from './components/CustomersUI';

const Customers = () => {
  return (
    <CustomersUI />
  );
}

export default Customers;
